export const SET_WAREHOUSES_GRAPHS_FILTERS = 'SET_WAREHOUSES_GRAPHS_FILTERS';
export const CLEAR_WAREHOUSES_GRAPHS = 'CLEAR_WAREHOUSES_GRAPHS';

const INITIAL_STATE = {
  company: null,
  station: null,
};

export const warehousesGraphsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_WAREHOUSES_GRAPHS_FILTERS:
      return {
        ...state,
        [payload.key]: payload.data,
      };
    case CLEAR_WAREHOUSES_GRAPHS:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
